//
// Control the top level style via:
//
// '& .roundTab': {
//   height: '60px',
//   width: '100%',
// },
//
// Control the color via these css specs:
//
//
// '& .roundTabFlexCenterContent': {
//   backgroundColor: 'red',
//   // Additional content div styling
// },
//
// '& .roundTabColor': {
//   fill: 'red',
// },
//

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { memo } from 'react';

function RoundTab(props) {
  const {
    className,
    children = null,
    radiusPx,
    opacity,
    vertical,
    flip,
    backgroundColor,
    fill,
    zIndex,
    ...other
  } = props;

  let centerBorderRadius;
  switch (vertical) {
    case (true):
      switch (flip) {
        case (true):
          // Vertical left
          centerBorderRadius = `${radiusPx}px 0 0 ${radiusPx}px`;
          break;
        default:
          // Vertical right
          centerBorderRadius = `0 ${radiusPx}px ${radiusPx}px 0`;
          break;
      }
      break;
    default:
      switch (flip) {
        case (true):
          // Horizontal bottom
          centerBorderRadius = `0 0 ${radiusPx}px ${radiusPx}px`;
          break;
        default:
          // Horizontal top
          centerBorderRadius = `${radiusPx}px ${radiusPx}px 0 0`;
          break;
      }
      break;
  }

  const containerStyle = {
    opacity,
    zIndex,
  };

  const contentStyle = {
    borderRadius: centerBorderRadius,
    backgroundColor,
    fill,
  };

  return (
    <div
      className={classNames(
        'flex-1 order-2 flex items-center justify-center relative',
        className,
      )}
      {...other}
    >
      <div
        className={classNames(
          'h-full w-full flex relative',
          {
            'flex-col': vertical,
          },
        )}
        style={containerStyle}
      >
        <div
          className="flex-1 order-2 flex items-center justify-center relative p-0.5 roundTabFlexCenterContent"
          style={contentStyle}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

RoundTab.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  radiusPx: PropTypes.number.isRequired,
  opacity: PropTypes.number,
  vertical: PropTypes.bool,
  flip: PropTypes.bool,
  backgroundColor: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  zIndex: PropTypes.number,
};

export default memo(RoundTab);
